export const surveyBuilderTabs = {
  build: {
    key: 'build',
    label: 'Build',
  },
  preview: {
    key: 'preview',
    label: 'Preview',
  },
  journeyMap: {
    key: 'journeyMap',
    label: 'Journey Map',
  },
};
